import type {
  PropsWithChildren,
} from 'react';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Navigation from '@/components/Navigation';

import styles from './layout.module.css';

const StaticLayout = (props: PropsWithChildren) => {
  const {
    children,
  } = props;

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={styles.staticLayout}>
      <Navigation />

      <div className={styles.header}>
        <Header
          withLogo
          withActions
        />
      </div>

      <div className={styles.content}>
        {children}
      </div>

      <div className={styles.footer}>
        <Footer withInstall />
      </div>
    </div>
  );
};

export default StaticLayout;
